import { EnvelopeSimple } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { LegalLayout } from "@/components/SiteFooter";
import { Seo } from "@/components/Seo";

const FAQ = [
  ["When do TSP prices update?", "TSP funds price once a day after market close. We log the official prices from tsp.gov each weekday evening around 9:30 PM ET. Intraday figures on the Fund Prices page are estimates."],
  ["My Plaid connection failed. What now?", "Use Accounts & Sync to import a TSP PDF statement or CSV export, or type your fund shares in by hand. You can try Plaid again later."],
  ["Why doesn't my paycheck ledger match my LES?", "The ledger uses your Profile salary, contribution rate and match rules. Enter the actual amounts from your LES and mark each paycheck verified. Agency match shortfalls then show up on the dashboard."],
  ["How do I delete my account?", "Email us from the address on your account and we will remove your account and data."],
];

export default function Support() {
  return (
    <LegalLayout title="Support">
      <Seo title="Support" description="Get help with PillarWealth.io. Email support@atkinsmedia.io with questions about your TSP and IRA tracker." path="/support" />
      <p>Have a question, found a bug, or need help with your account? We read every message.</p>
      <a href="mailto:support@atkinsmedia.io" className="not-prose inline-flex items-center gap-2 rounded-full bg-slate-900 dark:bg-cyan-400 text-white dark:text-slate-900 px-5 py-3 no-underline font-medium my-2" style={{ textDecoration: "none", color: "inherit" }} data-testid="support-email-link">
        <EnvelopeSimple size={18} /> <span className="text-white dark:text-slate-900">support@atkinsmedia.io</span>
      </a>
      <p>Please include the email on your account and, for data issues, the page and date you were looking at. Never send passwords or full account numbers by email.</p>
      <h2>Common questions</h2>
      {FAQ.map(([q, a]) => <div key={q}><h3>{q}</h3><p>{a}</p></div>)}
      <h2>More</h2>
      <p>See our <Link to="/privacy">Privacy Policy</Link> and <Link to="/cookies">Cookie Policy</Link>. PillarWealth.io is an educational tool and does not give financial, tax or legal advice.</p>
    </LegalLayout>
  );
}
